import { createContext } from 'react';
export const SubscriptionContext = createContext(null);